/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IUpdateProfileMethods,
  UpdateProfileService,
  IUpdateKycMethods,
  UpdateKycService,
  SendOTPService,
  ISendOTPMethods,
  VerifyOTPService,
  IVerifyOTPMethods,
  IFormatTimelineDetailMethods,
  FormatTimelineDetailService,
  IBankAccountMethods,
  BankAccountService,
} from "./components";

export type MyAccountAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IUpdateProfileMethods &
  IUpdateKycMethods &
  ISendOTPMethods &
  IVerifyOTPMethods &
  IFormatTimelineDetailMethods &
  IBankAccountMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    new UpdateProfileService(),
    new UpdateKycService(),
    new SendOTPService(),
    new VerifyOTPService(),
    new FormatTimelineDetailService(),
    new BankAccountService(),
  ];
};

export const getAgent = () => {
  return createAgent<MyAccountAgent>({
    plugins: getPlugins(),
  });
};
